/**
 * @module experience/modify-cancellation
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const MODIFY_SELECT_LINES_CONSTANTS = {
  PREPAID: 'prepaid',
  ELSTS: 'ELSTS',
  UPSUS: 'UPSUS',
  LOST_STOLEN: 'Lost/Stolen',
  UNPAID: 'Unpaid',
  PRE_PAID: 'PREPAID',
};

export const ACTION_CODE_CONSTANTS = {
  CHANGESERVICESTATUS: 'CHANGESERVICESTATUS',
  SUBMIT: 'SUBMIT',
  CHECKOUT: 'CHECKOUT',
  PREPAID_CANCELLATION_CONST_RETAIN: 'RETAIN',
  ADD: 'ADD',
  RESUME: 'RESUME',
  REASON_CRR: 'CRR',
  CANCEL_REASON_CODE: 35,
};
